module.exports = __webpack_public_path__ + "static/SB-78be89c7f5c9323626cafb5115ccd8c3.jpg";